import {
  REGISTRY_BLOCK,
  readFaqRows,
  type LayoutBlock,
} from '@web-studio/shared-schemas';
import { LUCIDE_SSR_MESSAGE_CIRCLE, resolveSectionSsrIcon } from '../icons/lucideSsrIconNodes';
import { renderLucideIconHtml } from '../icons/renderIconHtml';
import { pickBlockField } from '../lib/localized';
import { escapeHtml } from './escape';

function renderFaqItemsHtml(
  items: ReturnType<typeof readFaqRows>,
  isLedger: boolean,
): string {
  if (items.length === 0) return '';
  if (isLedger) {
    const rows = items
      .map(
        (item) => `<div class="ws-faq__row" role="listitem">
      <h3 class="ws-faq__question">${escapeHtml(item.question)}</h3>
      <p class="ws-faq__answer">${escapeHtml(item.answer)}</p>
    </div>`,
      )
      .join('\n    ');
    return `<div class="ws-faq__list" role="list">
    ${rows}
  </div>`;
  }

  const details = items
    .map(
      (item, index) => `<details class="ws-faq__item" name="ws-faq"${index === 0 ? ' open' : ''}>
      <summary class="ws-faq__summary"><span class="ws-faq__question">${escapeHtml(item.question)}</span></summary>
      <div class="ws-faq__panel"><p class="ws-faq__answer">${escapeHtml(item.answer)}</p></div>
    </details>`,
    )
    .join('\n    ');
  return `<div class="ws-faq__list">
    ${details}
  </div>`;
}

export function renderFaqBlockHtml(block: LayoutBlock, locale: string): string {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const intro = pickBlockField(block.content, 'intro', locale);
  const items = readFaqRows(pickBlockField(block.content, 'faqItems', locale));
  const isLedger = block.registryBlockKey === REGISTRY_BLOCK.presentation.faqLedger;
  const arrangementClass = isLedger ? 'ws-faq--ledger' : 'ws-faq--accordion';
  const sectionIcon = resolveSectionSsrIcon(
    pickBlockField(block.content, 'sectionIcon', locale),
    LUCIDE_SSR_MESSAGE_CIRCLE,
  );
  const iconHtml = renderLucideIconHtml(sectionIcon.iconNode, {
    size: 'md',
    className: 'ws-faq__icon',
    name: sectionIcon.name,
  });

  return `<section class="ws-faq ${arrangementClass}" data-block-id="${escapeHtml(block.blockId)}" data-component="Faq_Block" id="faq">
  <div class="ws-faq__inner">
    <div class="ws-faq__header">
      ${iconHtml}
      ${sectionTitle ? `<h2 class="ws-faq__title">${escapeHtml(sectionTitle)}</h2>` : ''}
    </div>
    ${intro ? `<p class="ws-faq__intro">${escapeHtml(intro)}</p>` : ''}
    ${renderFaqItemsHtml(items, isLedger)}
  </div>
</section>`;
}
